import { render, staticRenderFns } from "./Norm.vue?vue&type=template&id=758dc1de&scoped=true&"
import script from "./Norm.vue?vue&type=script&lang=js&"
export * from "./Norm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758dc1de",
  null
  
)

export default component.exports